import random from 'toxilibs/random.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'base_numeric_simple',
    dependencies: []
})


function common (q, params) {
    q.addText('Base' + params.base + '(' + params.x + ') = ?')
    q.answer = parseInt(params.x, params.base)
}


level.addQuestion({
    generator: function (q) {
        let base = random.fairChoiceInt(3, 10, {name: 'base'})
        common(q, {
            base,
            x:    random.fairChoiceInt(0, base - 1, {name: 'x'})
        })
    },
    times: 2
})


level.addQuestion({
    generator: function (q) {
        let base = random.fairChoiceInt(20, 36, {name: 'base'})
        common(q, {
            base,
            x:    10
        })
    },
    times: 2
})


level.addQuestion({
    generator: function (q) {
        let base = random.fairChoiceInt(5, 36, {name: 'base'})
        common(q, {
            base,
            x:    11
        })
    }
})


level.addQuestion({
    generator: function (q) {
        let base = random.fairChoiceInt(2, 4, {name: 'base'})
        common(q, {
            base,
            x:    11
        })
    }
})


level.addQuestion({
    generator: function (q) {
        let base = random.fairChoiceInt(6, 36, {name: 'base'})
        common(q, {
            base,
            x:    random.fairChoiceInt(12, 15, {name: 'x'})
        })
    }
})


level.addQuestion({
    generator: function (q) {
        let base = random.fairChoiceInt(3, 5, {name: 'base'})
        common(q, {
            base,
            x:    12
        })
    }
})



level.addQuestion({
    generator: function (q) {
        let base = random.fairChoiceInt(3, 15, {name: 'base'})
        common(q, {
            base,
            x:    20
        })
    }
})


level.addQuestion({
    generator: function (q) {
        let base = random.fairChoiceInt(3, 9, {name: 'base'})
        common(q, {
            base,
            x:    21
        })
    }
})

level.addQuestion({
    generator: function (q) {
        let base = random.fairChoiceInt(3, 9, {name: 'base'})
        common(q, {
            base,
            x:    22
        })
    }
})

level.addQuestion({
    generator: function (q) {
        let base = random.fairChoiceInt(4, 12, {name: 'base'})
        common(q, {
            base,
            x:    30
        })
    }
})

level.addQuestion({
    generator: function (q) {
        let base = random.fairChoiceInt(4, 12, {name: 'base'})
        common(q, {
            base,
            x:    31
        })
    }
})




export default level
